export default __webpack_public_path__ + "static/media/Iroka_Chidinma_Joy_AHV_In_Moms_We_Trust.e18bb3f4.jpg";